<template>
    <section class="section px-0 py-0">
        <div class="columns is-multiline is-mobile mx-0">
            <div class="column is-12" :class="canCreateFolders?'pb-0':'pb-5'">
                <p class="is-size-4 is-capitalized">
                    {{ $t('hello') }}, {{ userCompleteName }}
                </p>
            </div>
            <div
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen new-folder" v-if="canCreateFolders"
            >
                <a class="lb-folder-box" @click="$emit('create-folder')">
                    <figure class="lb-folder-box-content creation">
                        <p class="lb-folder-box-title is-uppercase">
                            <span class="icon-text mr-2">
                                <span class="icon pt-1">
                                    <i
                                        class="mdi mdi-24px mdi-folder-plus-outline"
                                    ></i>
                                </span>
                            </span>
                            {{ $t('Project.new_folder') }}
                        </p>
                    </figure>
                </a>
            </div>
            <div
                v-for="folder in folders"
                :key="folder._id"
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen lb-project-card existent-folder"
                @dragenter.prevent
                @dragover.prevent
                @drop="handleDrop($event, folder)"
            >
                <dashboard-folder
                    :folder="folder"
                    @edit="editFolder"
                    @delete="deleteFolder"
                />
            </div>
        </div>
        <new-folder-modal
            @create="saveFolder"
            v-if="creationEnabled"
            @cancel="disableCreation"
        />
    </section>
</template>

<script>
import { createItem, fetchItems, deleteItem, updateItem } from '@/services/API';
import DashboardFolder from '@/components/DashboardFolder';
import NewFolderModal from '@/components/NewFolderModal';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    components: {
        DashboardFolder,
        NewFolderModal,
    },
    data() {
        return {
            folders: [],
            creationEnabled: false,
        };
    },
    computed: {
        userCompleteName() {
            return (
                this.$store.getters.user.name + " " + this.$store.getters.user.surname
            );
        },
        canCreateFolders() {
            // console.log(this.$store.getters.activePlan)
            if (this.$store.getters.activePlan) {
                // console.log(this.$store.getters.activePlan.configuration.general.projectFolders)
                return true==this.$store.getters.activePlan.configuration.general.projectFolders || "true"==this.$store.getters.activePlan.configuration.general.projectFolders
            }
            return false;
        }
    },
    props: {
        createFolder: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.fetchFolders();
        // console.log('aqui',this.canCreateFolders);
    },
    watch: {
        createFolder: {
            handler: function () {
                // console.log('creating folder', this.createFolder);
                if (this.createFolder) {
                    this.creationEnabled = true;
                }
            },
            immediate: true,
        },
    },
    methods: {
        handleDrop(ev, folder) {
            var project = ev.dataTransfer.getData('project');
            this.$emit('addProject', project, folder);
        },
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        async saveFolder(name) {
            if (!name || !name.length) {
                return;
            }
            const response = await createItem('folder', { name });
            await this.fetchFolders();
            this.creationEnabled = false;
            this.$emit('folderCreated');
        },
        deleteFolder(item) {
            Swal.fire({
                title: this.$t('remove_folder_title'),
                text: this.$t('delete_object_confirmation_message'),
                showCancelButton: true,
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.removeFolder(item);
                }
            });
        },
        async removeFolder(item){
            let response = await deleteItem('folder', item._id);
                if (response.data == 'SUCCESS') {
                    // console.log('removing item', item._id);
                    this.folders = _.filter(this.folders, (folder) => {
                        return folder._id != item._id;
                    });
                    this.$emit('folderUpdated');
                } else {
                    console.error('impossible to delete folder');
                }
        },
        async editFolder(folder) {
            const { value: folderName } = await Swal.fire({
            title: this.$t('folder') + ' ' +folder.name,
            input: "text",
            inputLabel: this.$t('folder_new_name'),
            folderName,
            showCancelButton: true,
            confirmButtonText: this.$t('userProfile.leave_school_continue'),
            cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            customClass: {container: 'swal2-container input-alert'},
            inputValidator: (value) => {
                if (!value) {
                return this.$t('folder_new_name_needed');
                }
            }
            });
            if (folderName) {
                folder.name = folderName
            }
            const response = await updateItem('folder', folder._id, folder);
            this.$emit('folderUpdated');
            await this.fetchFolders();
            /*let name = window.prompt(
                this.$t('Folders.create_folder'),
                folder.name
            );
            // console.log({ name });
            if (!name || !name.length) {
                return;
            }
            folder.name = name;
            const response = await updateItem('folder', folder._id, folder);
            // console.log(response.data);
            await this.fetchFolders();*/
        },
        disableCreation(){
            this.$emit('cancel')
            this.creationEnabled = false;
        }
    },
};
</script>
<style scoped>
@import '../assets/css/swal-eduloc.css';

</style>
